import { render, staticRenderFns } from "./TheMainSidebarAndAsidebar.vue?vue&type=template&id=17221a48&"
import script from "./TheMainSidebarAndAsidebar.vue?vue&type=script&lang=js&"
export * from "./TheMainSidebarAndAsidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports